import React, { useEffect } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { InTheLab } from './components/InTheLab';
import { Differentiators } from './components/Differentiators';
import { StudioStory } from './components/StudioStory';
import { LabFaq } from './components/LabFaq';
import { SiteFooter } from './components/SiteFooter';
const FAVICON_SRC = 'https://cdn.magicpatterns.com/uploads/cJwwyWvBbSVniE9YkS37im/black-comet-cat-favicon-transparent.png';
export function App() {
  useEffect(() => {
    document.title = 'Black Comet Labs — Small studio. Big apps.';

    // Favicon: the approved transparent seated-cat PNG (matches Publish metadata).
    document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"], link[rel="shortcut icon"]').forEach(link => link.parentNode?.removeChild(link));
    const icon = document.createElement('link');
    icon.rel = 'icon';
    icon.type = 'image/png';
    icon.setAttribute('sizes', '1280x1280');
    icon.href = FAVICON_SRC;
    document.head.appendChild(icon);
  }, []);
  return <div className="min-h-full w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="3mlax56bfqdtg">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-[2px] focus:bg-ink focus:px-5 focus:py-3 focus:text-sm focus:text-cream" data-id="element-1" data-mp="3mjg7xft4rzjk">
        Skip to content
      </a>
      <SiteHeader data-id="element-2" data-mp="2zm4zaoz9bl3x" />
      <main id="main" data-id="element-3" data-mp="2zmo6bandcp36">
        <Hero data-id="element-4" data-mp="2zn678kkz7rhf" />
        <InTheLab data-id="element-5" data-mp="33mowttnqsqql" />
        <Differentiators data-id="element-6" data-mp="33m5bs42spm8c" />
        <StudioStory data-id="element-7" data-mp="33nggq77z9011" />
        <LabFaq data-id="element-8" data-mp="33myjb79kwfrj" />
      </main>
      <SiteFooter data-id="element-9" data-mp="38m1g64fenfof" />
    </div>;
}